import { render, staticRenderFns } from "./analysePanel.vue?vue&type=template&id=ba2ae52a&scoped=true&"
import script from "./analysePanel.vue?vue&type=script&lang=js&"
export * from "./analysePanel.vue?vue&type=script&lang=js&"
import style0 from "./analysePanel.vue?vue&type=style&index=0&id=ba2ae52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2ae52a",
  null
  
)

export default component.exports